import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Column, Divider, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C2Text, C3Text } from "../../../common/components/text/CustomText";
import { CustomDropdownBoxButton } from "../../../common/components/button/CustomDropdownBoxButton";
import { useEffect, useState } from "react";
import DeviceService from "../../../service/DeviceService";
import { CustomTable, EventRow } from "../../../common/components/table/CustomTable";
import CustomIcon from "../../../common/components/image/CustomIcon";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

const filterValue = [
    { value: "all", label: "All" },
    { value: "error", label: "Error" },
];


// event 값이 "{'2': 'Cooling'}" 형태 문자열로 내려옴 → 라벨만 추출
const parseEventLabel = (event) => {
    if (typeof event !== "string") return "";
    const matched = event.match(/'([^']*)'\s*}\s*$/);
    return matched ? matched[1] : event;
};

function DeviceHistoryModal({ isOpen, onClose, device, isSecondaryModal, currentDevice }) {
    const deviceService = new DeviceService();
    const [filter, setFilter] = useState("all");
    const [data, setData] = useState([]);
    const [timesUsed, setTimesUsed] = useState("0");
    const [earned, setEarned] = useState("0");

    useEffect(() => {
        if (!isOpen || !device?.id) return;
        deviceService
            .getDeviceDetailsHistory({ deviceId: device.id })
            .then((result) => {
                setData(Array.isArray(result?.history) ? result.history : []);
                setTimesUsed(String(result?.revenue?.used ?? 0));
                setEarned(String(result?.revenue?.earn ?? 0));
            })
            .catch((error) => {
                console.error("Error fetching device history:", error);
            });
    }, [isOpen, device?.id]);

    const tableHeaders = [
        {
            key: "date",
            label: Translate("store.deviceMenu.history.time"),
            maxWidth: "150px",
            whiteSpace: "normal",
            render: (row) => {
                const [datePart, timePart] = (row.date ?? row.time ?? "").split(" ");
                return (
                    <Column>
                        <C3Text>{datePart}</C3Text>
                        <C3Text>{timePart}</C3Text>
                    </Column>
                );
            },
        },
        {
            key: "event",
            label: Translate("store.deviceMenu.history.event"),
            render: (row) => <EventRow>{parseEventLabel(row.event)}</EventRow>,
        },
        {
            key: "detail",
            label: Translate("store.deviceMenu.history.detail"),
        },
    ];

    let side;
    let width;
    let paddingRight;
    let overlayColor;
    if (currentDevice === "mobile" || currentDevice === "tablet") {
        side = "center";
        width = "60vw";
    } else {
        side = "right";
        width = "552px";
    }

    if ((currentDevice === "mobile" || currentDevice === "tablet") && isSecondaryModal) {
        paddingRight = undefined;
        overlayColor = undefined;
    } else if (isSecondaryModal) {
        paddingRight = "1140px";
        overlayColor = "transparent";
    } else {
        paddingRight = undefined;
        overlayColor = undefined;
    }

    return (
        <CustomModal
            title={"History"}
            isOpen={isOpen}
            onClose={onClose}
            side={side}
            paddingRight={paddingRight}
            overlayColor={overlayColor}
            contentPadding={"20px 0"}
            width={width}
            height={"100%"}
        >
            <Padding padding={"0 20px"}>
                <Row>
                    <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.type")}</C3Text>
                    <SizedBox width={"8px"} />
                    <C3Text>{device.type}</C3Text>
                    <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                    <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.name")}</C3Text>
                    <SizedBox width={"8px"} />
                    <C3Text>{device.name}</C3Text>
                    <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                    <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.model")}</C3Text>
                    <SizedBox width={"8px"} />
                    <C3Text>{device.model}</C3Text>
                </Row>
                <Divider marginTop={"12px"} thickness={"0"} />
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.id")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.id}</C3Text>
            </Padding>
            <Divider marginTop={"20px"} marginBottom={"12px"} />
            <Padding padding={"0 20px"}>
                <Row alignItem={"center"} justifyContent={"space-between"} width={"100%"}>
                    <CustomDropdownBoxButton
                        icon={"filter"}
                        currentValue={filter}
                        setValue={setFilter}
                        values={filterValue}
                    />
                    <Row alignItem={"center"}>
                        <C3Text fontColor={Theme.color.rose500} marginLeft={"12px"}>
                            {Translate("store.deviceMenu.history.timesUsed", [timesUsed])}
                        </C3Text>
                        <Divider
                            orientation={"vertical"}
                            height={"12px"}
                            marginLeft={"6px"}
                            marginRight={"6px"}
                            color={Theme.color.rose500}
                        />
                        <C3Text fontColor={Theme.color.rose500} marginLeft={"12px"}>
                            {Translate("store.deviceMenu.history.earned", [earned])}
                        </C3Text>
                    </Row>
                </Row>
                <SizedBox height={"12px"} />
                {data.length > 0 && <CustomTable headers={tableHeaders} data={data} minWidth={"none"} />}
            </Padding>
            {data.length <= 0 && (
                <Column width={"100%"} height={"75%"} alignItem={"center"} justifyContent={"center"}>
                    <CustomIcon iconName={"alarm"} size={"24px"} />
                    <SizedBox height={"12px"} />
                    <C2Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.history.empty")}</C2Text>
                </Column>
            )}
        </CustomModal>
    );
}

export default DeviceHistoryModal;
